import { OptionCard } from './OptionCard'
import { OptionsGrid } from './styles/OptionCardStyles'
import { QuestionTitle } from './styles/SignUpFlowStyles'
import { SESSION_GOAL_OPTIONS } from '../../constants/surveyOptions'
import { Typography } from 'antd'

const MAX_SELECTIONS = 2

interface SurveyStepUseCasesProps {
  values: string[]
  onChange: (values: string[]) => void
}

export function SurveyStepUseCases({ values, onChange }: SurveyStepUseCasesProps) {
  const handleToggle = (value: string) => {
    if (values.includes(value)) {
      onChange(values.filter((v) => v !== value))
    } else if (values.length < MAX_SELECTIONS) {
      onChange([...values, value])
    }
  }

  const atLimit = values.length >= MAX_SELECTIONS

  return (
    <div>
      <QuestionTitle>What would make today a win?</QuestionTitle>
      <Typography.Text
        type="secondary"
        style={{ display: 'block', textAlign: 'center', marginBottom: 16, marginTop: -8 }}
      >
        Choose up to {MAX_SELECTIONS}
      </Typography.Text>
      <OptionsGrid>
        {SESSION_GOAL_OPTIONS.map((option) => {
          const isSelected = values.includes(option.value)
          const isDisabled = atLimit && !isSelected
          return (
            <div
              key={option.value}
              style={{ opacity: isDisabled ? 0.45 : 1, transition: 'opacity 0.2s' }}
            >
              <OptionCard
                label={option.label}
                isSelected={isSelected}
                onClick={() => handleToggle(option.value)}
                isMultiSelect={true}
              />
            </div>
          )
        })}
      </OptionsGrid>
    </div>
  )
}
